// extracted by mini-css-extract-plugin
module.exports = {"content":"dd31006766--content--n9d4w","content-mobile":"dd31006766--content-mobile--vvue9"};